<template>
    <div>
        <div class="summary-item d-flex flex-row justify-content-center mb-3">
            <div class="d-flex flex-column align-items-center mr-4" v-b-tooltip.hover
                title="Datos generales del documento.">
                <b-avatar variant="primary" size="3rem" class="mb-1">
                    <i class="fa fa-building"></i>
                </b-avatar>
                <small>Datos generales</small>
            </div>
            <div class="d-flex flex-column align-items-center mr-4" v-b-tooltip.hover
                title="Componentes.">
                <b-avatar variant="success" size="3rem" class="mb-1">
                    <i class="fa fa-flask"></i>
                </b-avatar>
                <small>Componentes</small>
            </div>
            <div class="d-flex flex-column align-items-center mr-4" v-b-tooltip.hover
                title="Sistema de clasificación.">
                <b-avatar variant="warning" size="3rem" class="mb-1">
                    <i class="fa fa-list-ul"></i>
                </b-avatar>
                <small>Sistema de clasificación</small>
            </div>
            <div class="d-flex flex-column align-items-center" v-b-tooltip.hover
                title="EPPs.">
                <b-avatar variant="info" size="3rem" class="mb-1">
                    <i class="fa fa-shield"></i>
                </b-avatar>
                <small>EPPs</small>
            </div>
        </div>

        <b-alert show variant="info" class="mt-1 mb-0">
            <i class="fa fa-exclamation-triangle"></i>
            Revisión Requerida: Esta información será generada mediante Inteligencia Artificial (IA). Te
            recomendamos validarla cuidadosamente para confirmar su exactitud antes de proceder.
        </b-alert>

    </div>
</template>

<script>
export default {
    name: "CreationSummary"
};
</script>

<style scoped>
.summary-item {
    opacity: 1;
    background:  linear-gradient(135deg, #e5fcfd 0%, #f8f8f8 100%);
    border-bottom: 4px solid #b8f7fa;
    padding: 10px;
}
</style>